import { createContext } from 'react';
import type {
  LineupTabResponse,
  PlayersTabResponse,
  StatisticsTabResponse,
  TableTabResponse,
  TeamInfoApiData,
} from '../types';

export type Status = 'success' | 'error' | 'pending';

export interface PrematchDataContextType {
  teamInfo: TeamInfoApiData | null;
  statistics: StatisticsTabResponse | null;
  table: TableTabResponse | null;
  players: PlayersTabResponse | null;
  lineup: LineupTabResponse | null;
  statisticsStatus: Status;
  tableStatus: Status;
  playersStatus: Status;
  lineupStatus: Status;
  refetchAll: () => void;
}

const PrematchDataContext = createContext<PrematchDataContextType | null>(null);

export default PrematchDataContext;
